import React from 'react';
const changes = [{
  title: '⚡ Stop Learning Randomly',
  description: 'Follow one complete roadmap instead of wasting time jumping between videos, forums, and scattered tutorials.'
}, {
  title: '👷 Install With Confidence',
  description: 'Understand how to plan, configure, troubleshoot, and complete professional Smart Home installations.'
}, {
  title: '💰 Build A New Income Opportunity',
  description: 'Develop practical skills that allow you to offer Smart Home installation services to residential clients.'
}, {
  title: '🚀 Work Like A Professional',
  description: 'Use proven workflows, documentation, checklists, and systems that make every project more organized and efficient.'
}];
export function ChangeSection() {
  return <section className="bg-white px-4 py-5" data-id="element-25" data-mp="1xb9dboyhbrbd">
      <div className="mx-auto max-w-4xl" data-id="element-26" data-mp="1x9g6o9nv973d">
        <h2 className="mb-3 text-center font-display text-xl font-extrabold uppercase sm:text-3xl" data-id="element-27" data-mp="22b5hppb39krg">
          What Will Change
        </h2>
        <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-28" data-mp="3dbb4menjkfw8">
          {changes.map(change => <article key={change.title} className="rounded-xl border border-brand-line bg-brand-light p-3 shadow-sm" data-id="element-29" data-mp="39b0yn1zr1phd">
              <h3 className="font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-30" data-mp="3i3cexv15fwjm">
                {change.title}
              </h3>
              <p className="mt-0.5 text-xs font-normal leading-snug text-brand-muted sm:text-sm" data-id="element-31" data-mp="2ugcmj4zufsss">
                {change.description}
              </p>
            </article>)}
        </div>
      </div>
    </section>;
}